module.exports = __webpack_public_path__ + "static/media/banner2.078928a4.png";